module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="xMessageInline ';
 if(typeof(action)!=='undefined'){ 
__p+='xMessage'+
((__t=( NGX.Util.capitalize(action) ))==null?'':__t)+
'';
 } 
__p+='">\n    <div class="xMessageInner">\n        ';
 if(typeof(title)!=="undefined"){
__p+='<h1 class="xTitle xHeadline">'+
((__t=( title ))==null?'':_.escape(__t))+
'</h1>';
 } 
__p+='\n        ';
 if(typeof(msg)!=="undefined"){ 
__p+='<p class="xCopy">'+
((__t=( msg ))==null?'':_.escape(__t))+
'</p>';
 } 
__p+='\n    </div>\n</div>';
}
return __p;
};
